import { useField } from "formik";
import { filter, get } from "lodash";
import React, { useMemo } from "react";

import { SelectOption } from "components/form/SelectOption";
import { AccountType } from "types/api/deal/accounting/ledger_account";
import {
  ACCOUNT_TYPE_OPTIONS,
  validAccountTypeMap,
} from "types/form/ledgerAccountForm";

export function AccountTypeField() {
  const [normalSizeField] = useField("normal_side");

  const filteredOptions = useMemo(() => {
    const validTypes: AccountType[] = get(
      validAccountTypeMap,
      normalSizeField.value,
      []
    );
    return filter(ACCOUNT_TYPE_OPTIONS, (option) =>
      validTypes.includes(option.key as AccountType)
    );
  }, [normalSizeField.value]);

  return (
    <SelectOption
      fieldName={"account_type"}
      displayName={"Account Type"}
      options={filteredOptions}
    />
  );
}
